import { useQuery, QueryObserverBaseResult } from "react-query"
import { queryKeys } from "../query"
import { GetUnloadingTermsRequestQuery, UnloadingTermsResponseData } from "../types/order"
import api from "../client"

const getData = async (getUnloadingTermsQueryParams: GetUnloadingTermsRequestQuery) => {
  const { unloadingCountryCode, loadingCountryCode, loadingDate } = getUnloadingTermsQueryParams
  const { data } = await api.get(`/unloadings/terms/${loadingCountryCode}/${unloadingCountryCode}/${loadingDate}`)
  return data
}

export const useUnloadingTerms = (
  getUnloadingTermsQueryParams: GetUnloadingTermsRequestQuery,
  isOrderEditable: boolean,
): QueryObserverBaseResult<UnloadingTermsResponseData> => {

  const { unloadingCountryCode, loadingCountryCode, loadingDate } = getUnloadingTermsQueryParams

  const { data, ...props } = useQuery<UnloadingTermsResponseData>(
    queryKeys.UNLOADING_TERMS(getUnloadingTermsQueryParams),
    () => getData(getUnloadingTermsQueryParams),
    {
      enabled: Boolean(
        unloadingCountryCode &&
        loadingCountryCode &&
        loadingDate &&
        isOrderEditable
      )
    }
  )

  return { data, ...props }
}
